module.exports = __webpack_public_path__ + "3a1ae9af.svg";